import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {FormGroup, FormArray, FormControl, Form, FormBuilder, Validators} from '@angular/forms';


import {apiUrl}  from '../global';

import {ResponseApi} from '../response-api';
import {ProfileDiscoveryService} from '../profile-discovery.service';
import {SharedService} from '../shared.service';

function validateEmail(c: FormControl) {
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  return EMAIL_REGEXP.test(c.value) ? null : {
    validateEmail: {
      valid: false
    }
  };
}

@Component({
  selector: 'app-topic',
  templateUrl: './topic.component.html',
  styleUrls: ['./topic.component.css']
})
export class TopicComponent implements OnInit {
  campaignId: number;
  responseApis: ResponseApi[];
  loginAttempt: ResponseApi[];
  error: any;
  backgroundColor: string;
  fadeOutLoader: boolean;
  fadeOutLoaderLogin: boolean;
  logo: any;
  logoSuper: any;
  domainList: any;
  userListType: boolean;
  hasUserList: boolean;
  form: any;
  attemptToSubmit: boolean;
  showLoaderLogin: boolean;
  textError: string;
  identifierForServer: string;
  currentQuestion: any;
  baseUrl: any;
  lengthOfQuiz: any;
  orderInQuiz: any;
  signatureUrl: string;

  slideIn: boolean;

  handicap: boolean;
  homme: boolean;
  forco: boolean;


  genericVal: any;
  nextQuestion: any;

  response: any;


  loadBarUntilDec: any;

  evaluation: any;
  fadeoutEvaluation:any;
  fadeinEvaluation:any;

  shareWhoAmI: any
  fadeinShareWhoAmI

  dec: any;
  fadeoutDec:any;
  fadeinDec:any;


  finalProfileImage:any;
  finalProfileTitle:any;
  finalProfileSubTitle:any;
  finalProfileText:any;

  pdfLink:any;


  constructor(private router: Router, private quizService: ProfileDiscoveryService, private route: ActivatedRoute, private sharedService: SharedService) {
    this.attemptToSubmit = true;

    this.fadeOutLoaderLogin = false;
    this.showLoaderLogin = false;

    this.textError = "";
    this.getUrl;
    this.currentQuestion = false;
    this.slideIn = false;
    this.nextQuestion = false;
    this.dec = false;
    this.signatureUrl = "empty";
  }

  setBackgroundColor(backgroundColor: string): void {
    this.sharedService.setBackgroundColor(backgroundColor);
  }

  getBackgroundColor() {
    return this.sharedService.getVal('backgroundColor');
  }

  getUrl(url: string): void {
    if(localStorage.getItem('hash') != null){
      this.quizService
        .getUrl(url, localStorage.getItem('hash'))
        .then(responseApi => {
          this.responseApis = responseApi;
          if (this.responseApis['success'] == false) {
            this.router.navigate(['page-not-found']);
          }
          else {
            var m = this;
            setTimeout(function () {
              m.fadeOutLoader = true;
              m.logo = apiUrl + m.responseApis[0]['data']['logo'][0]['path'];
              m.loaderFadedAway();
            }, 2000);

            this.response = this.responseApis[0]['data'];

            this.setBackgroundColor(this.responseApis[0]['data']['generalDetails'][0]['background_color']);
            this.backgroundColor = this.responseApis[0]['data']['generalDetails'][0]['background_color'];
            this.campaignId = this.responseApis[0]['data']['generalDetails'][0]['id'];

            if(this.backgroundColor == "#fecf05" || "#C2A392"){
              this.signatureUrl = "images/signature-email.png";
              this.homme = false;
              this.handicap = true;
              this.logoSuper = "assets/images/logo-final-handicap.png"
            }
            else if(this.backgroundColor == "#65ea9e"){
              this.signatureUrl = "images/homme-femme-signature.png";
              this.homme = true;
              this.handicap = false;
              this.logoSuper = "assets/images/homme-femme-signature-super.png"
            }
            console.log(this.signatureUrl);


            var questions = this.responseApis[0]['data']['questions'];

            var sumAnswersResponded = 0;
            var nonDefined = 0
            var lowestIndexOfUnrepliedQuestion = Infinity;
            for (var i = 0; i < questions.length; i++) {
              if (questions[i]['question_id'] > 0) {
                var tmpObj = questions[i].question['answers'];
                var tmpQuestion = questions[i];
                var answer = false;
                for (var j = 0; j < tmpObj.length; j++) {
                  if (tmpObj[j].checked == true) {
                    answer = true;
                  }
                }
                if (answer) {
                  sumAnswersResponded += 1;
                }
                else {
                  if (tmpQuestion['order_in_quiz'] < lowestIndexOfUnrepliedQuestion) {
                    lowestIndexOfUnrepliedQuestion = tmpQuestion['order_in_quiz'];
                  }
                }
              }
              else {
                nonDefined += 1;
              }
            }
            /*if (sumAnswersResponded+nonDefined != questions.length) {
             console.log(questions);
             console.log('here we should have been redirected but it is all good now');
             this.router.navigate([this.route.params['_value'].url + '/questionnaire/' + lowestIndexOfUnrepliedQuestion + '/2']);
             }
             else {
             this.dec =true;
             this.evaluation =false;
             this.shareWhoAmI =false;
             }*/
            this.dec =true;
            this.evaluation =false;
            this.shareWhoAmI =false;
          }

        })
        .catch(error => this.error = error);
    }
    else{
      this.router.navigate([this.route.params['_value'].url]);
    }
  }

  loaderFadedAway() {
    //this.logo = true;
  }

  postAuthenticate(url: string, username: string): void {
    this.quizService
      .postAuthenticate(url, username)
      .then(responseApi => {
        this.loginAttempt = responseApi;
        var thing = this;
        this.fadeOutLoaderLogin = true;
        setTimeout(function () {

          thing.fadeOutLoaderLogin = false;
          thing.showLoaderLogin = false;
          thing.textError = thing.loginAttempt['msg'];
          localStorage.setItem('auth', thing.loginAttempt['token']);
          localStorage.setItem('hash', thing.loginAttempt['username']);
          //this.router.navigate(['page-not-found']);
        }, 1000);

      })
      .catch(error => this.error = error);
  }

  loginUser() {
    if (!this.form.valid) {
      this.attemptToSubmit = false;
    }
    else {
      this.attemptToSubmit = true;
      var formValues = this.form.value;
      if (typeof formValues.identifier == 'undefined') {
        this.identifierForServer = formValues.email;
      }
      else {
        this.identifierForServer = formValues.identifier + '@' + formValues.email;
      }
      this.showLoaderLogin = true;
      this.textError = "";
      this.postAuthenticate(this.route.params['_value'].url, this.identifierForServer);
    }
  }

  passToEvaluation() {
    this.getUrlOfPdf(this.route.params['_value'].url, function(result, m){
      console.log(result.link);
      console.log(result.link != false)
      if(result.link != false){
        m.pdfLink = result.link;
      }
    });
    var responseCounter = {a: 0, b: 0, c: 0};
    for (var i = 0; i < this.response.questions.length; i++) {
      if(this.response.questions[i]['question_id'] > 0){
        for (var j = 0; j < this.response.questions[i].question.answers.length; j++) {

          if (this.response.questions[i].question.answers[j].checked) {
            if (this.response.questions[i].question.answers[j].rate == 'a') {
              responseCounter.a += 1;
            }
            if (this.response.questions[i].question.answers[j].rate == 'b') {
              responseCounter.b += 1;
            }
            if (this.response.questions[i].question.answers[j].rate == 'c') {
              responseCounter.c += 1;
            }
          }
        }
      }
    }
    console.log(responseCounter);
    var finalDef = '';
    if(responseCounter.a > responseCounter.b && responseCounter.a > responseCounter.c){
      finalDef = 'a';
    }
    if(responseCounter.b > responseCounter.a && responseCounter.b > responseCounter.c){
      finalDef = 'b';
    }
    if(responseCounter.c > responseCounter.a && responseCounter.c > responseCounter.b){
      finalDef = 'c';
    }

    if(responseCounter.a == responseCounter.b && responseCounter.b == responseCounter.c && responseCounter.c == responseCounter.a){
      finalDef = 'b';
    }

    if(responseCounter.a == responseCounter.b && responseCounter.b > responseCounter.c){
      finalDef = 'a';
    }
    if(responseCounter.a == responseCounter.c && responseCounter.c > responseCounter.b){
      finalDef = 'a';
    }
    if(responseCounter.b == responseCounter.c && responseCounter.b > responseCounter.a){
      finalDef = 'b';
    }

    this.fadeoutDec = true;
    for(var k = 0; k <this.response.profiles.length;k++){
      if(this.response.profiles[k]['rate'] == finalDef){
        this.finalProfileImage = this.response.profiles[k]['img'];
        this.finalProfileTitle = this.response.profiles[k]['title'];
        this.finalProfileSubTitle = this.response.profiles[k]['sub_title'];
        this.finalProfileText = this.response.profiles[k]['description'];
      }
    }

    var m = this;
    setTimeout(function () {
      m.evaluation = true;
      m.dec = false;
    }, 1000);

  }

  markAnswer(elem: any) {
  }

  passToNextQuestion() {
    if (this.nextQuestion != false && this.nextQuestion != parseInt(this.route.params['_value'].index)) {
      this.router.navigate([this.route.params['_value'].url + '/questionnaire/' + this.nextQuestion]);
    }
    else {
    }
  }

  updateTopic(elem: number) {
    console.log(elem);
    console.log('made it!!!');
    this.quizService
      .updateTopic(elem, this.campaignId)
      .then(responseApi => {
        this.responseApis = responseApi;
        if (this.responseApis['success'] == false) {
          //this.router.navigate([this.route.params['_value'].url + '/login']);
          this.router.navigate([this.route.params['_value'].url + '/merci']);
        }
        else {
          var m = this;
          /*setTimeout(function () {
            m.passToNextQuestion();
          }, 1000);
          this.slideIn = true;
          this.getUrl(this.route.params['_value'].url);*/
          this.router.navigate([this.route.params['_value'].url + '/merci']);
        }

      })
      .catch(error => this.error = error);
  }
  passToShareWhoAmI(){
    this.fadeoutEvaluation = true
    this.dec = false;
    var m = this;
    setTimeout(function () {
      m.evaluation = false;
      m.shareWhoAmI = true;
      m.fadeinShareWhoAmI = true;
    }, 1000);
  }


  getUrlOfPdf(url: string, genericFunction:any): void {
    this.quizService
      .getUrlOfPdf(url)
      .then(responseApi => {
        this.responseApis = responseApi;
        return genericFunction(this.responseApis, this);
      })
      .catch(error => this.error = error);
  }
  openPdf(elem:any){
    window.open(this.baseUrl + this.pdfLink);
  }

  ngOnInit(): void {
    this.backgroundColor = '#ffffff'
    this.fadeOutLoader = false;
    this.logo = false;
    this.baseUrl = apiUrl;
    this.getUrl(this.route.params['_value'].url);

    this.handicap = true;
    this.homme = false;

    if(this.route.params['_value'].url == 'forco')
    {
      this.forco = true;
    }
    else{
      this.forco = false;
    }
    console.log(this.forco);
    console.log(this.route.params['_value'].url);

    this.genericVal = this.route.params.subscribe(params => {
      const term = params['index'];
      this.getUrl(this.route.params['_value'].url);
    });
  }
}



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/topic/topic.component.ts